// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f8c71de2","59":"7b0fe3bd","122":"4a6957e6","160":"26811f8b","229":"fecf5277","248":"e6f6af1e","509":"71880f42","584":"98365957","587":"dc63f767","688":"1d5c6b92","886":"3f16d3eb","928":"c8229338"}[chunkId] + ".chunk.js";
};